<template>
  <b-card>
    <div
      class="label-container"
      :class="size"
    >
      <!-- Header -->
      <b-card-body class="pt-1 pb-0 px-1 mb-75">
        <b-row align-v="end">
          <!-- Header: Left Content -->
          <b-col>
            <div class="logo-wrapper">
              <b-img
                :src="logo"
                alt="logo"
                width="120px"
              />
            </div>
            <p class="card-text">
              {{ data.invoice_number }}
            </p>
          </b-col>
          <!-- Header: Right Content -->
          <b-col
            cols="auto"
          >
            <div
              class="mt-md-0 mt-2 text-right"
              :class="{ 'pl-1': data.delivery_insurance_fee, 'px-1': !data.delivery_insurance_fee }"
            >
              <b class="text-uppercase">{{ data.delivery.courier }}</b>
              <div>{{ data.delivery.service }}</div>
              <div
                v-if="data.delivery_insurance_fee"
                class="mt-25"
              >
                <small>Asuransi<span v-if="showInsuranceFee">: {{ toCurrency(data.delivery_insurance_fee) }}</span></small>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-card-body>

      <!-- Spacer -->
      <hr
        v-if="showBarcode && data.delivery.airway_bill"
        class="mb-50 mt-25"
      >

      <div
        v-if="showBarcode && data.delivery.airway_bill"
        class="text-center"
      >
        <div>Airwaybill Number</div>
        <barcode
          :value="data.delivery.airway_bill"
          width="2"
          height="40"
          font-size="14"
        />
      </div>

      <!-- Spacer -->
      <hr
        class="mb-0"
        :class="{'mt-25': data.delivery.airway_bill}"
      >

      <!-- Packing Label Client & Merchant -->
      <b-card-body
        class="px-1"
        body-class="py-1"
      >
        <b-row>
          <!-- Col: Packing Label To -->
          <b-col
            cols="7"
          >
            <h6 class="mb-25">
              Kepada:
            </h6>
            <div class="font-weight-bold mb-25 s-14">
              {{ data.delivery.consignee_name }}
            </div>
            <span class="s-12">
              {{ data.delivery.fullAddress }}
            </span>
          </b-col>
          <!-- Col: Payment Details -->
          <b-col
            cols="5"
          >
            <div>
              <h6 class="mb-25">
                Dari:
              </h6>
              <div class="font-weight-bold mb-25 s-14">
                {{ data.merchant.name }}
              </div>
              <span class="s-12 line-height-1">
                {{ data.merchant.address.district_name }}, {{ data.merchant.address.city_name }}
              </span>
              <div><small>081286867893</small></div>
            </div>
          </b-col>
        </b-row>
      </b-card-body>

      <!-- Spacer -->
      <hr class="mt-0 mb-50">

      <!-- Packing Label Product: Table -->
      <b-card-body
        v-show="showProduct"
        class="pt-0 px-1"
        body-class="pt-25 pb-1"
      >
        <b-table-simple
          borderless
        >
          <b-thead class="light-header">
            <b-tr>
              <b-th class="text-left pl-0 pb-0 pt-0">
                Produk
              </b-th>
              <b-th class="text-right pr-0 pb-0 pt-0">
                Jumlah
              </b-th>
            </b-tr>
          </b-thead>
          <b-tbody>
            <b-tr
              v-for="(item, index) in data.items"
              :key="`item-data-${index}`"
            >
              <b-td class="pl-0 pb-0">
                <div class="d-flex">
                  <div class="mr-1">
                    {{ index + 1 }}.
                  </div>
                  <dl class="mb-0">
                    <dt>
                      {{ item.product.name }}
                    </dt>
                    <span
                      v-if="item.attribute_concat"
                      class="mr-25"
                    >{{ item.attribute_concat }}</span>
                    <dt v-if="item.sku_name">
                      ({{ item.sku_name }})
                    </dt>
                  </dl>
                </div>
              </b-td>
              <b-td class="text-right pb-0 pr-0 d-flex">
                <div class="d-flex justify-content-end ml-auto">
                  {{ item.qty }} Pcs
                </div>
              </b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>
      </b-card-body>

      <!-- Note -->
      <b-card-body
        class="pt-0 pb-1"
        :class="showProduct ? '' : 'mt-1'"
        body-class="px-1"
      >
        <div
          v-if="data.use_gift_wrap"
          class="gift-wrap-container mb-50 s-12"
        >
          <feather-icon
            icon="GiftIcon"
            size="16"
            class="mr-50"
          />
          <span><strong>Penjual wajib</strong> membungkus kado</span>
        </div>
        <p class="mb-0 s-12">
          Catatan: Wajib merekam proses unboxing untuk mengajukan komplain.
        </p>
      </b-card-body>
    </div>
  </b-card>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BCardBody,
  BImg,
  BTableSimple,
  BTr,
  BTbody,
  BThead,
  BTh,
  BTd,
} from 'bootstrap-vue'
import { $themeConfig } from '@themeConfig'
import VueBarcode from 'vue-barcode'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardBody,
    BImg,
    BTableSimple,
    BTr,
    BTbody,
    BTd,
    BThead,
    BTh,
    barcode: VueBarcode,
  },
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
    size: {
      type: String,
      default: 'a4',
    },
    showProduct: {
      type: Boolean,
      default: true,
    },
    showBarcode: {
      type: Boolean,
      default: true,
    },
    showInsuranceFee: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      logo: $themeConfig.app.appLogoImage,
    }
  },
  computed: {
    hideCourier() {
      return [
        '94a909cf315647ca8b72d39ccd089abd',
        '967e13bca5544f2d9d3ce1241a5ae702',
        '94a90a0482854479ae1a5aae5fdf5e53',
        '97d02d9a03b04faf96a95f7418cc7ae6',
        '978baf73fb014f809ce6b2c276819147',
        '94ff5a4363f74892aa1b25d9533ed03f',
        '9777520af1c0404695a079ca848995f4',
        '9777529d6d5d47e79a625041642017d3',
        '9742e31ae1194970b04dcd4f9c2ae38f',
        '952e0f8de55d48f69831b60b9c975e43',
      ]
        .includes(this.data.merchant.id)
    },
  },
  methods: {
    getPhone(phone) {
      if (!phone) {
        return null
      }

      let phoneNew = phone

      if (phoneNew[0] === '6' && phoneNew[1] === '2') {
        phoneNew = phoneNew.substr(2, phoneNew.length - 2)
        phoneNew = `0${phoneNew}`
      }

      return phoneNew
    },
  },
}
</script>

<style lang="scss" scopped>
.label-container {
    border: 2px dotted #888888;

    &.a4 {
        width: 50%;
    }

    &.a6 {
        width: 100%;
    }
}

.light-header {
  th {
    background-color: transparent !important;
  }
}

.s-12 {
  font-size: 12px;
}

.s-16 {
  font-size: 16px;
}

.gift-wrap-container {
  border: 1px solid #d8d6de;
  padding: 8px 10px;
  border-radius: 4px;
  display: flex;
  align-items: flex-start;
  background-color: #fafafb;
  color: #5e5873;
}

.gift-wrap-container i,
.gift-wrap-container svg {
  margin-top: 1px;
  min-width: 16px;
  min-height: 16px;
  display: block;
  flex-shrink: 0;
}

.gift-wrap-container span {
  line-height: 1.3;
}
</style>
